import { camelize } from '@warp-drive/utilities/string';

/**
 * Camelize the keys of a JSON:API resource's `attributes` map.
 *
 * The app's request handlers can negotiate either camelized or dasherized
 * JSON:API member names depending on the `x-json-api-key-format` header, so
 * parsers camelize attribute keys to read them uniformly (`upload-url` and
 * `uploadUrl` both resolve to `uploadUrl`). Values are passed through untouched
 * — callers coerce/validate per field. A missing `attributes` map yields `{}`.
 *
 * Shared by the raw-`store.request()` response parsers (`match-period`,
 * `match-plan`, `eligibility-file-actions`) that read JSON:API documents
 * directly rather than through serializers.
 */
export function camelizeAttributes(
  attributes: Record<string, unknown> | undefined
): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(attributes ?? {})) {
    out[camelize(key)] = value;
  }
  return out;
}
